import { defineComponent as a, h as r } from "vue";
import n from "./ghl-ui.es906.js";
import t from "./ghl-ui.es1030.js";
import f from "./ghl-ui.es862.js";
import { resolveSlot as s } from "./ghl-ui.es860.js";
import i from "./ghl-ui.es1494.js";
const x = a({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    onClear: Function
  },
  setup(e, {
    slots: l
  }) {
    return () => {
      const {
        clsPrefix: o
      } = e;
      return r(n, {
        clsPrefix: o,
        class: `${o}-base-suffix`,
        strokeWidth: 24,
        scale: 0.85,
        show: e.loading
      }, {
        default: () => e.showArrow ? r(t, {
          clsPrefix: o,
          show: e.showClear,
          onClear: e.onClear
        }, {
          placeholder: () => r(f, {
            clsPrefix: o,
            class: `${o}-base-suffix__arrow`
          }, {
            default: () => s(l.default, () => [r(i, null)])
          })
        }) : null
      });
    };
  }
});
export {
  x as default
};
